module.exports = __webpack_public_path__ + "static/img/zjrm.9106732.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/zjrm.png
// module id = D/Jx
// module chunks = 0